// extracted by mini-css-extract-plugin
export default {"featuredSwiper":"FeaturedWorks_featuredSwiper__XPTg8"};